import React, { FunctionComponent, useState } from 'react';
import { graphql } from 'gatsby';
import { IPropsJobsIndex } from '../../types/jobsTypes';
import Layout from '../../components/Layout';
import Hero from '../../components/jobs/Hero';
import JobsList, {
  ALL_OFFICES,
  ALL_TEAMS,
} from '../../components/jobs/JobsList';
import StickyJobNavbar from './StickyJobNavbar';
import OurChallengesSection from './OurChallengesSection';
import OurPeopleSection from './OurPeopleSection';
import FAQSection from './FAQSection';

const Index: FunctionComponent<IPropsJobsIndex> = ({ data }) => {
  const { allHoverJobs, allHoverOffices, allHoverDepartments } = data;

  const [office, setOffice] = useState(ALL_OFFICES);
  const [department, setDepartment] = useState(ALL_TEAMS);

  return (
    <Layout
      isNavInitiallyWhite
      title="Job Opportunities"
      description="HOVER is building the future of 3D property data. We are a small team that works hard and loves to celebrate our wins."
      additionalMetadata={[
        {
          property: 'og:image',
          content: '../../images/LinkedIn-Open-Graph-photo.webp',
        },
        {
          name: 'twitter:image',
          content: '../../images/LinkedIn-Open-Graph-photo.webp',
        },
        { property: 'og:image:width', content: '972' },
        { property: 'og:image:height', content: '512' },
      ]}
    >
      <Hero />
      <StickyJobNavbar />
      <OurChallengesSection />
      <OurPeopleSection />
      <JobsList
        allJobs={allHoverJobs.nodes}
        allDepartments={allHoverDepartments.nodes}
        allOffices={allHoverOffices.nodes}
        selectedOffice={office}
        selectedDepartment={department}
        setOffice={setOffice}
        setDepartment={setDepartment}
      />
      <FAQSection />
    </Layout>
  );
};
export default Index;

export const query = graphql`
  query JobsPage {
    allHoverJobs {
      nodes {
        id
        title
        office
        department
        offices {
          id
          name
        }
        departments {
          id
          name
        }
      }
    }
    allHoverOffices {
      nodes {
        id
        name
      }
    }
    allHoverDepartments {
      nodes {
        id
        name
      }
    }
  }
`;
